( function( $ ) {
	let initBlock = function( section = false ) {
		const $section = section ? $( section ) : $( '.section-media-content' );

		$section.each( function() {
			let $sectionInstance = $( this );
			if ( $sectionInstance.find( '.js-section-media-content' ) && $sectionInstance.find( '.js-section-media-content-thumbs' ) ) {

				let $sliderServiceIntro = $sectionInstance.find( '.js-section-media-content' );
				let $sliderServiceIntroThumbs = $sectionInstance.find( '.js-section-media-content-thumbs' );

				const loadSliders = () => {
					let sliderServiceIntroThumbs = new Swiper( $sliderServiceIntroThumbs[0], {
						slidesPerView: 'auto',
						speed: 1000,
						spaceBetween: 4,
						centerInsufficientSlides: true,
						slideToClickedSlide: true,
						rewind: true,
						a11y: {
							enabled: false
						},
						breakpoints: {
							768: {
								spaceBetween: 10,
							},
						},
						on: {
							init: function( sliderServiceIntroThumbs ) {
								if ( window.matchMedia( '(min-width: 1280px)' ).matches ) {
									sliderServiceIntroThumbs.changeDirection( 'vertical' );
								} else {
									sliderServiceIntroThumbs.changeDirection( 'horizontal' );
								}
							},
							resize: function( sliderServiceIntroThumbs ) {
								if ( window.matchMedia( '(min-width: 1280px' ).matches ) {
									sliderServiceIntroThumbs.changeDirection( 'vertical' );
								} else {
									sliderServiceIntroThumbs.changeDirection( 'horizontal' );
								}
							},
							click: function( swiper, event ) {
								let $swiperSlideClicked = $( event.target ).closest( '.js-section-media-content-thumbs .swiper-slide' );
								if ( $swiperSlideClicked.length ) {
									let activeIndex = $swiperSlideClicked.attr( 'data-slide-index' );
									sliderServiceIntroThumbs.slideTo( activeIndex, 1000 );
								}
							}
						},
					} );
		
					new Swiper( $sliderServiceIntro[0], {
						slidesPerView: 1,
						speed: 1000,
						spaceBetween: 0,
						rewind: true,
						effect: 'fade',
						simulateTouch: false,
						allowTouchMove: false,
						fadeEffect: {
							crossFade: true,
						},
						thumbs: {
							swiper: sliderServiceIntroThumbs,
						},
						breakpoints: {
							1280: {
								spaceBetween: 10,
							},
						},
						on: {
							activeIndexChange: function( swiper ) {
								let activeIndex = swiper.activeIndex;
								sliderServiceIntroThumbs.slideTo( activeIndex, 1000 );
							}
						},
					} );
				};
				
				window.app.loadVendor( 'Swiper', loadSliders );
			}
		} );
	};

	window.app.loadBlock( initBlock, 'section-media-content', '.section-media-content' );
} )( jQuery );